var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureShieldGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.8,73.61l72.92,18.37L190.2,14.16l-104.68,127.57L9.8,73.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m27.29,69.77v-20.87l.95-1.01c.86-.91,21.48-22.22,62.09-22.22,23.97,0,40.95,7.36,51.25,13.81l9.13-6.61c-10.59-7.3-30.95-17.8-60.37-17.8-45.12,0-68.81,24.49-69.8,25.54l-3.85,4.07v22.41l10.6,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m153.38,71.64v21.14c0,5.6-.36,11.08-1.06,16.28-4.79,35.59-24.8,53.06-40.75,63.13-11.03,6.97-19.99,9.34-20.37,9.44l-.87.23-.87-.22c-.64-.17-15.85-4.21-31.18-17.45-13.02-11.24-28.71-29.83-30.75-63.87l-10.84-9.75v2.21c0,42.56,18.85,65.77,34.66,79.42,17.15,14.81,34.72,19.5,35.46,19.69l3.53.91,3.53-.91c1.1-.29,11.15-3.01,23.37-10.74,17.86-11.27,40.26-31.03,45.59-70.68.77-5.67,1.16-11.62,1.16-17.7v-34.06l-10.6,12.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureShieldGray);
export default __webpack_public_path__ + "static/media/secure-shield-gray.cc7eefc6348b91e61671bd0f2ca6ec17.svg";
export { ForwardRef as ReactComponent };